export default {
  data() {
    return {
      isLoading: false,
      switcherModel: true,
      admLevelsField: [],
      formFields: [],
      fileTypes: ['file-xlsx', 'file-csv', 'file-zip'],
      fieldErrors: {
        required: 'Обязательное поле',
        requiredFullList: 'Введите данные для каждого периода',
        int: 'В поле должно быть целое число',
        filezip: 'Некорректный формат файла. Допускается: .zip',
        filexls: 'Некорректный формат файла. Допускается: .xls или .xlsx',
        filecsv: 'Некорректный формат файла. Допускается: .csv',
        uploadingError: 'Ошибка загрузки файла'
      }
    }
  },
  computed: {
    workspaceList() {
      return this.$store.getters.activeWorkspaceList
    },
    workspace() {
      return this.$store.getters.workspace
    },
    version() {
      return this.$store.getters.version
    },
    admLevels() {
      return this.$store.getters.settings.administrative_levels ? this.$store.getters.settings.administrative_levels.filter((v) => v.adm_level !== 20) : []
    }
  },
  watch: {
    selectedServiceDetails(newVal) {
      let formFields = this.selectedServiceDetails
        .map((v) => {
          v.isVisible = true
          if (v.type === 'checkbox') {
            v.value = !!v.value
          }
          if (v.type === 'adm_levels') {
            const selected = v.value
            v.value = this.admLevels.map((v) => {
              return {
                ...v,
                isSelected: selected.indexOf(v.adm_level) > -1
              }
            })
          }
          if (v.type === 'select') {
            v.select = v.select.map((item) => {
              return {
                ...item,
                id: item.value
              }
            })
            const current = v.select.filter((item) => item.id === v.value)
            v.value = v.value && current[0] ? current[0] : null
          }

          if (v.type === 'list') {
            let defaultValue = ''
            if (!v.value || !v.value.length) {
              defaultValue = v.value
              v.value = [defaultValue]
            }
            if (v.value && v.value.length) {
              this.periodsDates.forEach((period, periodIndex) => {
                if (v.value.length === periodIndex) {
                  v.value.push(defaultValue)
                }
              })
            }
          }
          if (this.fileTypes.indexOf(v.type) > -1) {
            v = this.formatFileObject(v)
          }
          return {
            ...v,
            validated_options: v.validated_options || {},
            errors: []
          }
        })
        .sort((serviceParam1, serviceParam2) => {
          //Важно чтобы сортировка была после map, чтобы не модифицировать исходный массив
          if (typeof serviceParam1.priority === 'number' && typeof serviceParam2.priority === 'number') {
            return serviceParam1.priority - serviceParam2.priority
          }
          return 0
        })

      this.formFields = this.updateLinkedFields(formFields)
    }
  },

  mounted() {
    this.getParams()
  },
  methods: {
    dragoverprevent(e) {
      e.preventDefault()
    },
    updatePeriod(field, value) {
      field.value = value
    },
    formatFileObject(file) {
      file.url = file.value
      file.value = null
      file.filename = ''
      file.urlName = ''
      file.path = ''
      if (file.url) {
        const parts = file.url.split('/')
        file.urlName = parts[parts.length - 1]
        parts.splice(-1, 1)
        file.path = parts.join('/')
      }
      return file
    },
    addFile(e, field) {
      let droppedFiles = e.dataTransfer.files
      if (!droppedFiles || droppedFiles.length === 0) return
      this.changeFile(field, { target: { files: droppedFiles } })
    },
    changeFile(field, e) {
      if (this.validateFile(field, e.target.files[0])) {
        field.filename = e.target.files[0].name
        if (this.selectedService.id === 'workspace') {
          field.file = e.target.files[0]
          return
        }
        this.$store
          .dispatch('uploadFile', {
            model: 'setting',
            file: e.target.files[0],
            id: field.id
          })
          .then((v) => {
            field.value = v.body.file
            field = this.formatFileObject(field)
          })
          .catch((e) => {
            field.url = ''
            field.filename = ''
            field.value = ''
            field.errors.push('uploadingError')
          })
      } else {
        field.value = null
      }
    },
    validateFile(field, file) {
      field.errors = []
      const parts = file.name.split('.')
      const type = parts.length > 0 ? parts[parts.length - 1] : ''
      if (field.type === 'file-zip' && type !== 'zip') {
        field.errors.push('filezip')
      } else if (field.type === 'file-csv' && type !== 'csv') {
        field.errors.push('filecsv')
      } else if (field.type === 'file-xlsx' && type !== 'xls' && type !== 'xlsx') {
        field.errors.push('filexls')
      }
      return !field.errors.length
    },
    removeUrl(field) {
      const params = {
        model: 'setting',
        id: this.selectedService.id === 'workspace' ? field.name : field.id,
        file: null
      }
      this.$store
        .dispatch('resetModelingFile', params)
        .then((r) => {
          field.url = ''
        })
        .catch((e) => {
          this.$store.commit('setApiErrorInfo', 'Ошибка сброса файла')
        })
    },
    updateLinkedFields(formFields) {
      if (!formFields) formFields = this.formFields
      formFields
        .filter((field) => field.linked_params)
        .forEach((field) => {
          Object.keys(field.linked_params).forEach((param) => {
            const visibility = +param === +field.value
            field.linked_params[param].forEach((linkedFieldName) => {
              const linkedField = formFields.filter((v) => v.name === linkedFieldName)[0]
              linkedField.isVisible = visibility
            })
          })
        })

      return formFields
    },
    validateField(field) {
      field.errors = []
      if (field.required) {
        if (this.fileTypes.indexOf(field.type) > -1) {
          if (!field.url) {
            field.errors.push('required')
          }
        } else {
          if (!field.value) {
            field.errors.push('required')
          }
        }
        if (field.type === 'list' && field.value.filter((v) => v !== '' && !isNaN(parseFloat(v + ''))).length < this.periodsDates.length) {
          field.errors.push('requiredFullList')
        }
      }
      if (this.fileTypes.indexOf(field.type) > -1 && field.url) {
        const parts = field.url.split('.')
        const type = parts.length > 0 ? parts[parts.length - 1] : ''
        if (field.type === 'file-zip' && type !== 'zip') {
          field.errors.push('filezip')
        } else if (field.type === 'file-csv' && type !== 'csv') {
          field.errors.push('filecsv')
        } else if (field.type === 'file-xlsx' && type !== 'xls' && type !== 'xlsx') {
          field.errors.push('filexls')
        }
      }
    },
    generateRequestParams(fieldNameProperty) {
      const params = {}
      const files = {}
      this.formFields.forEach((v) => {
        this.validateField(v)
      })
      const errors = this.formFields.filter((v) => v.errors.length > 0)
      if (errors.length > 0) {
        return
      }
      this.formFields.forEach((v) => {
        if (this.fileTypes.indexOf(v.type) > -1) {
          if (this.selectedService.id === 'workspace') {
            files[v[fieldNameProperty]] = v.file
          } else {
            params[v[fieldNameProperty]] = v.url
          }
        } else if (v.type === 'adm_levels') {
          params[v[fieldNameProperty]] = v.value.filter((level) => level.isSelected).map((level) => level.adm_level)
        } else if (v.type === 'list') {
          params[v[fieldNameProperty]] = v.value.map((value) => parseFloat(value + ''))
        } else if (v.type === 'select') {
          params[v[fieldNameProperty]] = v.value ? v.value.id : null
        } else if (v.type === 'int') {
          params[v[fieldNameProperty]] = v.value || v.value === 0 ? parseInt(v.value + '') : null
        } else if (v.type === 'float') {
          params[v[fieldNameProperty]] = v.value || v.value === 0 ? parseFloat(v.value + '') : null
        } else {
          params[v[fieldNameProperty]] = v.value
        }
        if (!v.isVisible) {
          params[v[fieldNameProperty]] = ['adm_levels', 'list'].indexOf(v.type) > -1 ? [] : null
        }
      })
      return { params, files }
    },
    showCanCalculateNotification() {
      this.$store.commit('setApiErrorInfo', 'Превышены системные лимиты')
    },
    getFile(e, url) {
      e.preventDefault()
      this.$store.dispatch('getFile', url)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/serviceparameters.js